import React, { useMemo } from "react";
import { Table, Tag, Badge } from "antd";
import { RocketOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import WidgetWrapper from "../components/WidgetWrapper";
import { useLoadList } from "../../../hooks";
import { masterDataService } from "../../../api/enhancedApi";

const AircraftInfoWidget = () => {
    const navigate = useNavigate();

    // Load data using the same hook as the full list
    // We only need a small subset for the widget
    const { data, isLoading, refetch, error } = useLoadList("aircraft_widget", masterDataService.aircraft.getAircraftList, {
        page: 1,
        page_size: 5, // Only show top 5
        status: "ACTIVE", // Default to showing active aircraft
    });

    const columns = [
        {
            title: "注册号",
            dataIndex: "registration",
            key: "registration",
            render: (text) => (
                <Tag color="blue" style={{ border: "none" }}>
                    {text}
                </Tag>
            ),
        },
        {
            title: "机型",
            dataIndex: "aircraft_type",
            key: "aircraft_type",
        },
        {
            title: "状态",
            dataIndex: "status",
            key: "status",
            render: (status) => <Badge status={status === "ACTIVE" ? "success" : "error"} text={<span style={{ color: "var(--text-primary)" }}>{status === "ACTIVE" ? "启用" : "停用"}</span>} />,
        },
    ];

    const handleMore = () => {
        navigate("/master-data/aircraft");
    };

    return (
        <WidgetWrapper title="机队概览" loading={isLoading} onRefresh={refetch} extra={<a onClick={handleMore}>更多</a>}>
            <Table columns={columns} dataSource={data?.items || []} rowKey="registration" pagination={false} size="small" scroll={{ y: 200 }} />
        </WidgetWrapper>
    );
};

export default AircraftInfoWidget;
